import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import icon1 from "../../images/icon/sms-black.png";
import icon2 from "../../images/icon/call-balck.png";
import icon3 from "../../images/icon/loc-black.png";
import icon4 from "../../images/icon/sms02.svg";
import Services from "../../api/service";
import logo from "../../images/logo/Logo-2-01.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const SubmitHandler = (e) => {
  e.preventDefault();
};

const Downloadfooter = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <footer
      className="footer footer-style-two pt-50 bg_img pos-rel"
      style={{ backgroundColor: "#0c111d" }}
    >
      <div className="container">
        <div className="xb-footer ">
          <div className="footer-info ul_li_between">
            <div className="info-item ul_li">
              <div className="xb-item--icon">
                <span>
                  <img src={icon1} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Write to us</p>
                <h4 className="xb-item--title"><a href="mailto:hello@tigrispay.com" className="contacts-footer">hello@tigrispay.com</a></h4>
              </div>
            </div>
            <div className="info-item ul_li">
              <div className="xb-item--icon clr-blue">
                <span>
                  <img src={icon2} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Call Us</p>
                <h4 className="xb-item--title"><a href="tel:02030055883" className="contacts-footer">+44 02030055883</a></h4>
              </div>
            </div>
            <div className="info-item ul_li">
              <div className="xb-item--icon clr-sky">
                <span>
                  <img src={icon3} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Our Office</p>
                <h4 className="xb-item--title">
                  25 Cabot Square, Canary <br />Wharf, London,  E14 4QZ.
                </h4>
              </div>
            </div>
          </div>
          <div className="footer-inner mt-70 mb-100 ul_li_between align-items-start">
            <div className="sa-newslatter footer-widget">
              <img src={logo} style={{ maxWidth: "120px" }} alt="" />
              <br />
              <br />

              <p className="xb-item--content clr-white">
                Tigris Pay is the trading name of Fast Track Money Transfer Limited, registered at 25 Cabot Square, Canary Wharf, London, E14 4QZ (Company Registration Number: 06872129). Fast Track Money Transfer Limited is regulated by the Financial Conduct Authority (FCA) in the United Kingdom as an Authorised Payment Institution (FCA Registration Number: 647030).
              </p>
              {/* <p className="text-white">
       
        Write to us
      </p>
      <h4 className="text-white">
        <a href="mailto:hello@tigrispay.com" className="text-white text-decoration-none">
          <FontAwesomeIcon icon={faEnvelope} className="me-2 text-warning" />
          hello@tigrispay.com
        </a>
      </h4> */}

            </div>
            <div className="footer-widget">
              <span className="xb-item--sub-title">Quick Links</span>
              <ul className="xb-item--holder list-unstyled">
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/about-us">
                    About us
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/contact-us">
                    Contact Us
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/help">
                    Help
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/general-faq">
                    General FAQs
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-widget">
              <span className="xb-item--sub-title">Legal Links</span>
              <ul className="xb-item--holder list-unstyled">
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/terms-conditions">
                    Terms and Conditions
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/privacy-policy">
                    Privacy Policy
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/data-safety">
                    Data Safety
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/file-a-complaint">
                    File a Complaint
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-copyright mt-70 ul_li_between">
            <p className="copyright mt-20">
              Copyright © 2025{" "}
              <Link onClick={ClickHandler} to="/">
                Tigris Pay
              </Link>
              . All rights reserved.
            </p>
            <ul
              className="footer-link ul_li mt-20"
              style={{
                position: "relative",
                left: window.innerWidth <= 768 ? "0px" : "-100px",
                transition: "left 0.3s ease",
              }}
            >

              <li>
                <span>Follow us :</span>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/tigris-pay/" target="_blank">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>

              <li>
                <a href="https://www.instagram.com/tigris_pay/" target="_blank">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>

              <li>
                <a href="https://www.facebook.com/profile.php?id=61585032013966" target="_blank">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>



            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Downloadfooter;
